export enum TaskTodoType {
  EMAIL = 'Email',
  CALL = 'Call',
  LINKEDIN = 'Linkedin',
  IN_MAIL = 'InMail',
  VOICE_NOTE = 'VoiceNote',
  GENERIC = 'Generic',
}
